import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { AppConfig } from '../config/app.config';
import { IReturnObject } from '../shared/return-object.model';
import { Observable } from 'rxjs/Observable';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { PkgCodeBE } from './shared/packaging-code.model';

@Injectable()
export class PackagingCodeService {
    constructor(private config: AppConfig, private http: Http) { }

    private apiUrl: string = this.config.get('apiUrl') + "PackagingCode";

    getPackagingCodes(packagingCode: string): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetPackagingCodes/?searchTerm=${packagingCode}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getCodeSearchList(searchTerm: string, level: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetCodeSearchList/?searchTerm=${searchTerm}&level=${level}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getPackingCodeFor(codeId: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetPackingCodeFor/?codeId=${codeId}`)
            .map((response: Response) => <IReturnObject>response.json());
    } 7

    // Get packaging code for Packaging-Code-Page
    getPkgCodeFor(codeId: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetPkgCodeFor/?codeId=${codeId}`)
            .map((response: Response) => <IReturnObject>response.json());
    }


    // Get packaging code for Packaging-Code-Page
    getPkgCodeContraintInfo(codeId: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetPkgCodeContraintInfo/?codeId=${codeId}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getCodeConstraints(codeId: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetCodeConstraintsFor/?codeId=${codeId}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    codeExist(packagingCode: string): Observable<boolean> {
        return this.http.get(`${this.apiUrl}/CodeExist/?pkgCodeName=${packagingCode}`)
            .map((response: Response) => <boolean>response.json());
    }

    savePkgCode(packagingCode: PkgCodeBE): Observable<IReturnObject> {
        let headers: Headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        let body = JSON.stringify(packagingCode);
        let options = new RequestOptions({ headers: headers });

        return this.http.post(`${this.apiUrl}/SavePkgCode`, body, options)
            .map((response: Response) => <IReturnObject>response.json());
    }

    deletePkgCode(pkgCodeId: number): Observable<IReturnObject> {
        return this.http.delete(`${this.apiUrl}/DeletePkgCode/?pkgCodeId=${pkgCodeId}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    changeStatusPkgCode(pkgCodeId: number, statusId: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/ChangeStatusPkgCode/?pkgCodeId=${pkgCodeId}&statusId=${statusId}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

}


// WEBPACK FOOTER //
// C:/Users/NREGE3/Workspace/OnPremChina/PackITWebGui/src/app/packaging-code/packaging-code.service.ts